module.exports = __webpack_public_path__ + "img/greenmbp.e3a4513b.png";